(function () {
  const COLOR_MAP = {
    // standard
    "white": "#ffffff",
    "black": "#171717",
    "red": "#c9282d",
    "blue": "#2466a8",
    "green": "#4d8446",
    "yellow": "#f1cf36",
    "silver": "#b8bcc0",
    "grey": "#a5a7a8",
    "gray": "#a5a7a8",
    "gold": "#bd953f",
    "pink": "#d86d91",
    "olive": "#727447",
    "khaki": "#a69b65",
    "brown": "#665043",

    // Aircrafttag variants
    "dark brown": "#514136",
    "darkbrown": "#514136",

    "lightgrey": "#c4c6c6",
    "light grey": "#c4c6c6",

    "anthrazit": "#4b4e50",
    "anthracite": "#4b4e50",

    "lightblue": "#77aad2",
    "light blue": "#77aad2",

    "darkblue": "#173d67",
    "dark blue": "#173d67",

    "bold blue": "#1767a6",
    "warm red": "#c9463d",
    "sunrise yellow": "#efc933",
    "summit silver": "#b5b9ba",

    "light green": "#83ad73",
    "lightgreen": "#83ad73",

    "light red": "#dc716c",
    "lightred": "#dc716c",

    "hot pink": "#d94486",
    "flamingo": "#e94b7b",
    "purple": "#7b4b9e",
"coffee": "#7a5136",

    "sunshine": "#e7cf36"
  };


  const IGNORE_WORDS = [
    "frame",
    "package",
    "cut frame",
    "small frame"
  ];


  function normalize(text) {
    return text
      .toLowerCase()
      .replace(/[“”„"]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }


  /*
   * Returns color phrases found in the option value.
   * Long names are checked before short names so
   * "bold blue" isn't interpreted only as "blue".
   */
  function findColors(text) {
    const normalized = normalize(text);

    const names = Object.keys(COLOR_MAP).sort(
      (a, b) => b.length - a.length
    );

    const found = [];
    let workingText = normalized;

    names.forEach(function (name) {

      if (workingText.includes(name)) {

        const color = COLOR_MAP[name];

        if (!found.includes(color)) {
          found.push(color);
        }

        workingText = workingText.replaceAll(name, " ");
      }

    });

    return found.slice(0, 4);
  }


  function isNonColorOption(text) {
    const normalized = normalize(text);

    return IGNORE_WORDS.some(function (word) {
      return normalized.includes(word);
    });
  }


  function createSwatch(colors) {

    const swatch = document.createElement("span");
    swatch.className = "aircrafttag-auto-swatch";
    swatch.setAttribute("aria-hidden", "true");

    colors.forEach(function (color) {

      const part = document.createElement("span");
      part.style.backgroundColor = color;

      swatch.appendChild(part);

    });

    return swatch;
  }


  function initializeFieldset(fieldset) {

    if (fieldset.dataset.aircrafttagSwatchesInitialized === "true") {
      return;
    }

    const optionName = normalize(
      fieldset.dataset.optionName || ""
    );

    /*
     * Your shop currently uses names such as
     * Farbe / farbe and potentially Color / Colour.
     */
    const isColorOption =
      optionName === "farbe" ||
      optionName === "color" ||
      optionName === "colour" ||
      optionName === "couleur" ||
      optionName === "colore" ||
      optionName === "cor";


    if (!isColorOption) {
      return;
    }


    const labels = fieldset.querySelectorAll(
      'input[type="radio"] + label'
    );


    labels.forEach(function (label) {

      if (label.querySelector(".aircrafttag-auto-swatch")) {
        return;
      }

      const text = label.textContent.trim();


      /*
       * Keep obvious packages / frames as text buttons.
       */
      if (isNonColorOption(text)) {
        return;
      }


      const colors = findColors(text);

      /*
       * No recognizable color:
       * leave existing Shopify button untouched.
       */
      if (!colors.length) {
        return;
      }


      const swatch = createSwatch(colors);

      label.prepend(swatch);

    });


    fieldset.dataset.aircrafttagSwatchesInitialized = "true";
  }


  function initializeSwatches(root) {

    const scope = root || document;

    scope
      .querySelectorAll(".aircrafttag-variant-picker")
      .forEach(initializeFieldset);
  }


  document.addEventListener("DOMContentLoaded", function () {
    initializeSwatches(document);
  });


  /*
   * Shopify may replace portions of the product form
   * after variant / section updates.
   */
  const observer = new MutationObserver(function (mutations) {

    mutations.forEach(function (mutation) {

      mutation.addedNodes.forEach(function (node) {

        if (!(node instanceof HTMLElement)) {
          return;
        }

        if (
          node.matches &&
          node.matches(".aircrafttag-variant-picker")
        ) {
          initializeSwatches(node.parentElement);
        } else {
          initializeSwatches(node);
        }

      });

    });

  });


  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();